import { render, staticRenderFns } from "./DecorGoodsPicker.vue?vue&type=template&id=f4eb5ab4&scoped=true&"
import script from "./DecorGoodsPicker.vue?vue&type=script&lang=js&"
export * from "./DecorGoodsPicker.vue?vue&type=script&lang=js&"
import style0 from "./DecorGoodsPicker.vue?vue&type=style&index=0&id=f4eb5ab4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4eb5ab4",
  null
  
)

export default component.exports